import { Routes } from '@angular/router';

import { BlankPage } from './pages/blank/blank.page';

export const routes: Routes = [
  {
    path: ':token',
    component: BlankPage,
  },
  {
    path: '',
    component: BlankPage,
  },
];
